import * as amplitude from '@amplitude/analytics-browser';

import {getAmplitudePageUrlAllowlist} from 'analytics/amplitudePrivacy';
import {isSessionAnalyticsAllowed} from 'analytics/sessionTracking';
import BenchlingConfig from 'BenchlingConfig';

export function shouldInitializeAmplitude(apiKey: string | undefined): boolean {
  return Boolean(apiKey) && BenchlingConfig.ANALYTICS_ENABLE_AMPLITUDE && isSessionAnalyticsAllowed();
}

export function initializeAmplitude(apiKey: string | undefined): void {
  if (!shouldInitializeAmplitude(apiKey)) {
    return;
  }

  amplitude.init(apiKey!, {
    identityStorage: 'none',
    logLevel: window.debug ? amplitude.Types.LogLevel.Verbose : amplitude.Types.LogLevel.Warn,
    transport: 'xhr',
    autocapture: {
      pageViews: {
        trackHistoryChanges: 'pathOnly',
      },
      sessions: true,
      pageUrlEnrichment: true,
      attribution: false,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: {
        pageUrlAllowlist: getAmplitudePageUrlAllowlist(),
        dataAttributePrefix: 'data-test-',
        visualTaggingOptions: {
          enabled: true,
        },
        viewportContentUpdated: {
          enabled: false,
        },
      },
      frustrationInteractions: false,
      networkTracking: false,
      webVitals: false,
      performanceTracking: false,
    },
    trackingOptions: {
      ipAddress: false,
    },
  });

  if (window.bootstrapUser) {
    const userId = `${BenchlingConfig.TENANT_ID}:${window.bootstrapUser.id}`;
    const identify = new amplitude.Identify();
    for (const [key, value] of Object.entries(window.bootstrapUser.publicIdentifyTraits ?? {})) {
      identify.set(key, value);
    }
    identify.set('enabledCapabilityFeatures', window.bootstrap?.enabledCapabilityFeatures ?? []);
    amplitude.identify(identify, {user_id: userId});
  }
  amplitude.setGroup('tenant', BenchlingConfig.TENANT_ID);
}
